import * as dateFnsCompat from 'utils/date-fns-compat';

import he from 'he';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { connect } from "react-redux";
import { compose } from "recompose";
import { dateFormats } from '../../../../../constants';
import { fullName } from '../../../../../services';
import { currentUserSelector } from '../../../../../state/modules/user';
import { Icon } from '../../../../components';

const TaskBox = ({ task, stepTo, user }) => (
  <div id='task-box' className='boxed'>
    <Row className='no-gutter'>
      <Col xs={12} sm={8} lg={6} id='name'>
        <h2 className='name'>{task.name.value}</h2>
      </Col>
      <Col xs={12} sm={4} lg={6} id='due-date'>
        <h4><FontAwesome name='calendar-o' className='icon' />{`Due by ${dateFnsCompat.format(task.dueDate.value, dateFormats.ShortMonthLongDate)}`}</h4>
        <h4><Icon icon='user' />{`Set by ${he.decode(fullName(user))}`}</h4>
      </Col>
    </Row>
    <Row className='no-gutter'>
      <Col xs={12} sm={8} lg={6} id='description'>
        <p className='description'>{task.description.value}</p>
      </Col>
      <Col xs={12} sm={4} lg={6} id='edit'>
        <Button bsStyle='plain' className='edit-task' onClick={() => stepTo(0)}><Icon icon='edit-medium' />Edit task details</Button>
      </Col>
    </Row>
  </div>
)

const mapStateToProps = (state) => ({
  user: currentUserSelector(state)
})
const mapDispatchToProps = (dispatch) => ({})

export default compose(
  connect(mapStateToProps, mapDispatchToProps)
)(TaskBox)


// WEBPACK FOOTER //
// ./src/containers/pages/app/tasks/partials/task-box.js